import { FormControl } from "@angular/forms";

export interface WanUsage {
    enabled: string;
    flush_interval: number;
    monthly_quota_mb: number;
    reset_day: number;
};

export interface WanUsageForm {
    enabled: FormControl<string>;
    flush_interval: FormControl<number>;
    monthly_quota_mb: FormControl<number>;
    reset_day: FormControl<number>;
};